"use client";

import type { ConsentCategoryConfig } from "@homeinstead/locale";
import type { ReactNode } from "react";

import { createContext, useContext } from "react";

type PageBuilderRuntimeContextValue = {
  cookieConsent?: ConsentCategoryConfig;
  documentId: string;
};

const PageBuilderRuntimeContext =
  createContext<PageBuilderRuntimeContextValue | null>(null);

type PageBuilderRuntimeProviderProps = {
  children: ReactNode;
  cookieConsent?: ConsentCategoryConfig;
  documentId: string;
};

function PageBuilderRuntimeProvider({
  children,
  cookieConsent,
  documentId,
}: PageBuilderRuntimeProviderProps) {
  return (
    <PageBuilderRuntimeContext.Provider value={{ cookieConsent, documentId }}>
      {children}
    </PageBuilderRuntimeContext.Provider>
  );
}

function usePageBuilderCookieConsent(): ConsentCategoryConfig | undefined {
  return useContext(PageBuilderRuntimeContext)?.cookieConsent;
}

function usePageBuilderDocumentId(): string | null {
  return useContext(PageBuilderRuntimeContext)?.documentId ?? null;
}

function usePageBuilderRuntimeContext(): PageBuilderRuntimeContextValue | null {
  return useContext(PageBuilderRuntimeContext);
}

export {
  PageBuilderRuntimeProvider,
  usePageBuilderCookieConsent,
  usePageBuilderDocumentId,
  usePageBuilderRuntimeContext,
};
